import React from 'react';

const Footer = () => {
  return (
    <div className="footer-badge">
      <a
        href="https://stsol360.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="sts-badge-link"
        title="Software Testing Solutions"
      >
        <img
          src="/sts-logo-white.png"
          alt="Software Testing Solutions"
          className="sts-badge-logo"
        />
      </a>
    </div>
  );
};

export default Footer;
